module.exports = __webpack_public_path__ + "img/0665c81.png";